import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { REQUEST_STATUSES } from 'common/constants';
import { addQueryCases } from 'common/helpers';


const name = 'location';

const ENDPOINTS = { location: '/api/v1/location/' };

export const getLocation = createAsyncThunk(
  `${name}/getLocation`,
  async (_, { extra: api }) => {
    const response = await api.get(ENDPOINTS.location);
    return response.data.results;
  }
);

const initialState = {
  locationStatus: REQUEST_STATUSES.NOT_REQUESTED,
  location: [],
  locationError: null
};

const locationMapSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers(builder) {
    addQueryCases(builder, getLocation, {
      status: 'locationStatus',
      data: 'location',
      error: 'locationError',
      options: { concat: false },
    });
  }
});

export default locationMapSlice;

export const detailLocationMap = (state) => state[ name ];
